<template>
    <div class="footer">
        <span class="copyright">Copyright &copy; 2017-2022 浙江省服装产业创新服务综合体</span>
        <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备17056291号-3</a>
        <a class="beian" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011302000197" target="_blank">浙公网安备33011302000197号</a>

        
    </div>
</template>

<script>
export default {
    name: 'y-footer'
}
</script>

<style lang="scss" scoped>
.footer {
    flex: 0 0 auto;
    padding: 40px 20px;
    text-align: center;
    .copyright {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;

    }
    .beian {
        margin-left: 24px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        text-decoration: none;
        &:hover {text-decoration: underline;}
    }
}

</style>
